<template>
  <div class="flex-column">
    <!-- <el-dialog title="Tạo nhóm" :visible.sync="showCreatePopup"
               :close-on-click-modal="false" width="800px" top="40px"
               destroy-on-close @opened="setId()">
      <create-group ref="createGrMsg" :account-id="selectedAccount" :userId="data.userId" />
    </el-dialog> -->
    <div class="contact-detail-header px-1 py-2">
      <div class="d-flex">
        <el-select @change="changeSortType" v-model="selectedSortType" size="mini"
                   class="w-100px">
          <el-option v-for="sort in sortType" :key="sort.val" :label="sort.name"
                     :value="sort.val"></el-option>
        </el-select>
        <el-input @input="searchByName" placeholder="Tìm kiếm..." class="w-200px mx-2  contact-input"
                  size="mini"
                  v-model="searchKey"></el-input>
        <div class="flex-1" />
        <div class="px-3">
          <!-- <el-tooltip class="item pointer mx-1" effect="dark" content="Đồng bộ danh bạ từ Zalo về Salework"
                      placement="top">
            <el-button type="" size="mini" class="" @click="syncContact"><span>Đồng bộ</span><span
              class="icon-arrow-change mx-1" /></el-button>
          </el-tooltip> -->
        </div>
      </div>
    </div>
    <div class="divider-custom" />
    <div class="contact-item-list flex-1">
      <div v-for="contact in contacts" :key="contact.id">
        <div class="bg-white">
          <div class="contact-item py-2 px-3">
            <el-avatar :size="52" :src="contact.avatar"></el-avatar>
            <div class="flex-1 font-size-16 text-1-line mx-3">{{ contact.displayName }}</div>
            <el-tooltip content="Tạo nhóm" placement="top" effect="light">
              <el-image class="mx-3 pointer" @click="showPopup(contact)"
                        src="/assets/icon/add_group.svg" />
            </el-tooltip>

          </div>
          <div class="divider-custom"></div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center  mt-2">
      <el-pagination
        v-if="pageInfo.total > 1"
        background
        layout="prev, pager, next"
        :current-page="pageInfo.page"
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        @current-change="currentPageChanged"
        @prev-click="pageInfo.page -= 1"
        @next-click="pageInfo.page += 1"
      ></el-pagination>
      
    </div>
    <DialogCreateGroup
        v-if="dialogCreateGroup"
        :dialogCreateGroup="dialogCreateGroup"
        :account-id="selectedAccount"
        :userId="getUserId"
        @close="dialogCreateGroup = false" />
  </div>
</template>

<script>
  import DialogCreateGroup from "../message/DialogCreateGroup.vue";

export default {
  name: "Contact-list-zalo",
  components: { DialogCreateGroup },
  props: ["selectedAccount"],
  data() {
    return {
      profile: {},
      showCreatePopup: false,
      pageInfo: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      selectedSortType: "az",
      searchKey: "",
      sortType: [{ name: "Tên (A-Z)", val: "az" }, { name: "Tên (Z-A)", val: "za" }],
      contacts: [],
      dialogCreateGroup: false,
    };
  },
  watch: {
    selectedAccount: function() {
      this.searchByName();
    }
  },
  methods: {
    showPopup(conversation) {
      setTimeout(async () => {
        try {
          await this.getProfileInfo(conversation);
          this.dialogCreateGroup = true;
        } catch (err) {
          console.log("err", err);
        }
      }, 500);
    },
    // getProfileInfo(uid) {
    //   this.profile = {};
    //   this.$http.get("/api/message/getProfileInfo", {
    //     params: {
    //       accountId: this.selectedAccount,
    //       profileId: uid
    //     }
    //   }).then((reps) => {
    //     this.profile = reps.data.data.changed_profiles[uid];

    //   });
    // },
    getProfileInfo(conversation) {
      this.profile = {};
      return this.$http.post("/api/messageV2/getProfileInfo", {
        accountId: this.selectedAccount,
        toId: conversation.uid,
        group: conversation.group,
        page: conversation.page,
      })
        .then((resp) => {
          this.profile = this.parsedJSON(resp.data).data.changed_profiles[conversation.uid];
        })
        .catch(error => {
          console.error(`Failed to get profile info for conversation ID: ${conversation.uid}`, error);
          return {};
        });
    },
    parsedJSON(obj) {
      if (typeof obj === 'string') {
        try {
          return JSON.parse(obj);
        } catch (e) {
          console.error('Invalid JSON string:', e);
          return obj;
        }
      }
      return obj;
    },
    setId() {
      this.$refs.createGrMsg.setAccountId(this.selectedAccount);
    },
    currentPageChanged(newPage) {
      this.pageInfo.page = newPage;
      this.getContact();
    },
    searchByName() {
      this.pageInfo.page = 1;
      this.getContact();
    },
    getContact() {
      this.$http
        .get("/api/contact/filter", {
          params: {
            searchKey: this.searchKey,
            accountId: this.selectedAccount,
            page: this.pageInfo.page - 1,
            pageSize: this.pageInfo.pageSize
          }
        })
        .then(resp => {
          this.contacts = resp.data.content;
          this.changeSortType();
          this.pageInfo.total = this.totalContact = resp.data.totalElements;
          this.app.contactTotal.contact = this.totalContact;
        });
    },
    changeSortType() {
      if (this.selectedSortType == "az") {
        this.contacts.sort((a, b) => {
          if (a.displayName.toLowerCase() > b.displayName.toLowerCase()) return 1;
          if (a.displayName.toLowerCase() < b.displayName.toLowerCase()) return -1;
          return 0;
        });
      } else {
        this.contacts.sort((a, b) => {
          if (b.displayName.toLowerCase() > a.displayName.toLowerCase()) return 1;
          if (b.displayName.toLowerCase() < a.displayName.toLowerCase()) return -1;
          return 0;
        });
      }
    },
    syncContact() {
      localStorage.removeItem("contact");
      localStorage.removeItem("alias");
      this.$http
        .get("/api/account/getFriendList", {
          params: {
            accountId: this.selectedAccount
          }
        })
        .then(() => {
          this.alert("success", "Đồng bộ danh bạ thành công!");
        });
    }
  },
  beforeDestroy() {
    this.$bus.$off("closeCreateGrMsg");
  },
  mounted() {
    this.$bus.$on("closeCreateGrMsg", () => {
      this.showCreatePopup = false;
    });
  },
  created() {
    if (this.selectedAccount) {
      this.searchByName();
    }
  },
  computed: {
      getUserId() {
        if (!this.profile) {
          return null;
        } else {
          return this.profile.userId;
        }
      },
  }
};
</script>

<style scoped>

</style>